import store from "@/state/store";

const redirectIfLoggedIn = (routeTo, routeFrom, next) => {
  if (store.getters["auth/loggedIn"]) next({ name: "default" });
  else next();
};

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/account/login.vue"),
    meta: { title: "Login", beforeResolve: redirectIfLoggedIn },
  },
  {
    // Super admin CMS tổng vào thẳng CMS này bằng vé SSO (nút "Vào CMS" ở trang
    // Cộng tác viên của tổng). CỐ Ý không redirectIfLoggedIn: máy đang đăng nhập
    // tài khoản CTV thì phiên đó được thay bằng phiên "Super admin tổng".
    path: "/sso",
    name: "central-sso",
    component: () => import("@/views/account/central-sso.vue"),
    meta: { title: "Đăng nhập từ CMS tổng", authRequired: false },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/account/register.vue"),
    meta: { title: "Register", beforeResolve: redirectIfLoggedIn },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("@/views/account/forgot-password.vue"),
    meta: { title: "Forgot Password", beforeResolve: redirectIfLoggedIn },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        next();
      },
    },
    component: () => import("@/views/auth/logout/basic"),
  },
];
